import { deviceInfo } from "../utils/deviceinfo";
import { Renderer } from "./renderer";

export function createRenderer(): Renderer {
  const renderer = new Renderer({
    cameraPerspective: 75,
    cameraInitialYMove: 1500,
    backgroundColor: 0x01222f,
    foregroundColor: 0x009de4,
    lightColor: 0xffffff,
    lightStrenght: 2,
    blending: true,
    bloom: false,
    bloomRadius: 1,
    bloomStrength: 1,
    bloomThreshold: 0.3,
    ease: 6,
    opacity: 0.5,
  });

  window.addEventListener("resize", () => {
    renderer.resize();
  });

  window.addEventListener("mousemove", (e) => {
    renderer.setMouse(deviceInfo.mouseCenterX(e), deviceInfo.mouseCenterY(e));
  });

  document.addEventListener("scroll", () => {
    renderer.setScroll(deviceInfo.getScrollPercent());
  });

  return renderer;
}
